import * as React from 'react';
import { IPropsPassedMessage } from './IPropsPassedMessage';
import GuardedLink from '@apps/MessageApp/components/GuardedLink/GuardedLink';
import * as style from './PropsPassedMessageStyle.module.scss'


const PropsPassedMessage = ({ box }: IPropsPassedMessage): JSX.Element => {
  return (
    <>
      <h2 className={style.boxTitle}>
        {box.title.map((copy, i) => (
          <p key={copy.slice(0, 5) + i}>{copy}</p>
        ))}
      </h2>
      <h3 className={style.boxDescription}>
        {box.description.map((copy, i) => (
          <p dangerouslySetInnerHTML={{ __html: copy }} key={copy.slice(0, 5) + i} />
        ))}
      </h3>
      <div className={style.boxLinksWrapper}>
        {box.links.map((link, i) =>
        <GuardedLink key={link.url.slice(0, 5) + i} link={link}/>)}
      </div>
    </>
  );
};

export default PropsPassedMessage;
